/** For the `default` of a switch over a union: a variant added later breaks the build there. */
export function assertNever(value: never): never {
    throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}
